export const formatPrice = (price) => {
    const rubFormat = Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumSignificantDigits: 21 });
    return rubFormat.format(price)
}

export const formatNumber = number => Intl.NumberFormat('ru-RU').format(number, { maximumSignificantDigits: 21 });
